'use client';

export { default } from './Popover';
export * from './Popover';
export { default as popoverClasses } from './popoverClasses';
export * from './popoverClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Popover/index.js
// module id = 490
// module chunks = 22